import React, { useState } from "react";
import "./Component.css";
import { FaPlus, FaChevronDown, FaChevronUp, FaEdit, FaTrash, FaBox, FaMicrochip, FaMemory, FaHdd, FaCogs, FaWindows, FaVideo, FaSearch } from "react-icons/fa";

const componentList = [
  "Cabinet",
  "Motherboard",
  "CPU",
  "SMPS",
  "RAM",
  "SSD",
  "Graphics Card",
  "Operating System",
];

const iconMap = {
  Cabinet: <FaBox />,
  Motherboard: <FaMicrochip />,
  CPU: <FaCogs />,
  SMPS: <FaCogs />,
  RAM: <FaMemory />,
  SSD: <FaHdd />,
  "Graphics Card": <FaVideo />,
  "Operating System": <FaWindows />,
};

const ComponentMaster = () => {

  // #### STATE: dropdown open index
  const [openIndex, setOpenIndex] = useState(null);

  // #### STATE: search bar
  const [search, setSearch] = useState("");

  // #### STATE: submenu dynamic items
  const [items, setItems] = useState({
    Cabinet: ["Example Item 1", "Example Item 2"],
    Motherboard: ["Example Item 1"],
    CPU: ["Example Item 1"],
    SMPS: ["Example Item 1"],
    RAM: ["Example Item 1"],
    SSD: ["Example Item 1"],
    "Graphics Card": ["Example Item 1"],
    "Operating System": ["Example Item 1"],
  });

  // #### STATE: edit mode
  const [editItemIndex, setEditItemIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  // #### STATE: new item entry
  const [newItemValue, setNewItemValue] = useState("");

  // #### TOGGLE MENU
  const toggleMenu = (i) => {
    setOpenIndex(openIndex === i ? null : i);
    setEditItemIndex(null);
  };

  // #### START EDIT
  const startEdit = (value, index) => {
    setEditItemIndex(index);
    setEditValue(value);
  };

  // #### SAVE EDIT
  const saveEdit = (comp) => {
    const updated = [...items[comp]];
    updated[editItemIndex] = editValue;
    setItems({ ...items, [comp]: updated });
    setEditItemIndex(null);
  };

  // #### DELETE ITEM
  const deleteItem = (comp, index) => {
    const updated = items[comp].filter((_, i) => i !== index);
    setItems({ ...items, [comp]: updated });
  };

  // #### ADD NEW ITEM
  const addItem = (comp) => {
    if (!newItemValue.trim()) return;
    const updated = [...items[comp], newItemValue];
    setItems({ ...items, [comp]: updated });
    setNewItemValue("");
  };

  // #### FILTER COMPONENTS
  const filtered = componentList.filter((item) =>
    item.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="component-container">
    <h2 className="adcustompc-title">Custom PC Components</h2>
      {/* #### SEARCH BAR */}
      <div className="search-bar">
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search component..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {filtered.map((comp, index) => (
        <div key={index} className="component-card">

          {/* #### HEADER */}
          <div className="component-header">
            <h3>
              <span className="comp-icon">{iconMap[comp]}</span> {comp}
            </h3>

            <div className="header-right">

              {/* #### ADD BUTTON */}

              {/* #### TOGGLE SUBMENU */}
              <button className="toggle-btn" onClick={() => toggleMenu(index)}>
                {openIndex === index ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </button>
            </div>
          </div>

          {/* #### SUBMENU */}
          {openIndex === index && (
            <div className="submenu">
              <p className="submenu-title">Available Options</p>

              <ul>
                {items[comp].map((item, i) => (
                  <li key={i}>
                    
                    {/* #### EDIT MODE */}
                    {editItemIndex === i ? (
                      <>
                        <input
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                        />
                        <span className="sub-actions">
                          <button onClick={() => saveEdit(comp)}>Save</button>
                          <button onClick={() => setEditItemIndex(null)}>Cancel</button>
                        </span>
                      </>
                    ) : (
                      <>
                        {item}
                        <span className="sub-actions">
                          <button onClick={() => startEdit(item, i)}>
                            <FaEdit size={14} />
                          </button>
                          <button className="delete" onClick={() => deleteItem(comp, i)}>
                            <FaTrash size={14} />
                          </button>
                        </span>
                      </>
                    )}

                  </li>
                ))}
              </ul>

              {/* #### NEW ITEM INPUT */}
              <div className="new-item-row">
                <input
                  type="text"
                  placeholder="Add new item..."
                  value={newItemValue}
                  onChange={(e) => setNewItemValue(e.target.value)}
                />
                <button onClick={() => addItem(comp)}>Submit</button>
              </div>

            </div>
          )}

        </div>
      ))}

    </div>
  );
};

export default ComponentMaster;
